import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
      <div className="text-center max-w-3xl mx-auto mb-14 reveal">
        <span className="label-mono">// RECENSIONI</span>
        <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-5xl">
          I feedback di chi ha <span className="gold-text">seguito il corso</span>
        </h2>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
        {testimonials.map((t, i) => (
          <div
            key={i}
            style={{ transitionDelay: `${(i % 3) * 0.1}s` }}
            className="break-inside-avoid rounded-2xl border border-white/10 bg-[var(--uv-surface)] p-7 card-shine reveal-scale"
          >
            <div className="flex items-center justify-between">
              <Quote size={28} className="text-[var(--uv-gold)]/60" />
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="text-[var(--uv-gold)] fill-[var(--uv-gold)]" />
                ))}
              </div>
            </div>
            <p className="mt-4 text-neutral-300 leading-relaxed text-[0.95rem]">{t.text}</p>
            <div className="mt-5 font-display font-semibold text-white">{t.name}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
